module.exports = __webpack_public_path__ + "static/img/15-01.50f7707.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award/15-01.png
// module id = DH3i
// module chunks = 1